'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = ['M32 160c0 44.5 26 89.1 56.5 125.4 14.8 17.6 29.7 32 40.9 42 9.9 8.9 20.1 16.6 30.6 24.6 10.6-7.9 20.8-15.7 30.6-24.6 11.2-10 26.1-24.5 40.9-42 30.5-36.2 56.5-80.9 56.5-125.4 0-70.7-57.3-128-128-128S32 89.3 32 160zm48-16c0-35.3 28.7-64 64-64l16 0 0 32-16 0c-17.7 0-32 14.3-32 32l0 16-32 0 0-16zm63.3 272l33.5 0-16.7-41.8-16.7 41.8zM314.8 308.3c8.7 14.5 18.9 28.3 29.6 41.1 14.8 17.6 29.7 32 40.9 42 9.9 8.8 20.1 16.7 30.6 24.6 10.6-7.9 20.8-15.7 30.6-24.6 11.2-10 26.1-24.5 40.9-42 30.5-36.2 56.5-80.9 56.5-125.4 0-70.7-57.3-128-128-128-19.5 0-38 4.4-54.5 12.2 4.3 16.6 6.5 33.9 6.5 51.8 0 58.4-26.1 110-53.2 148.3zM399.3 480l33.5 0-16.7-41.8-16.7 41.8z', 'M231.5 285.4c-14.8 17.6-29.7 32-40.9 42-9.9 8.9-20.1 16.6-30.6 24.6-10.6-7.9-20.8-15.7-30.6-24.6-11.2-10-26.1-24.5-40.9-42-30.5-36.2-56.5-80.9-56.5-125.4 0-70.7 57.3-128 128-128S288 89.3 288 160c0 44.5-26 89.1-56.5 125.4zM143.3 416l16.7-41.8 16.7 41.8-33.5 0zM96 448l128 0-32-80s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368L96 448zm288-16l-32 80 128 0-32-80s128-96 128-208c0-88.4-71.6-160-160-160-23.1 0-45.1 4.9-64.9 13.7 4.2 9.8 7.7 20 10.4 30.4 16.5-7.8 35-12.2 54.5-12.2 70.7 0 128 57.3 128 128 0 44.5-26 89.1-56.5 125.4-14.8 17.6-29.7 32-40.9 42-9.9 8.8-20.1 16.7-30.6 24.6-10.6-7.9-20.8-15.7-30.6-24.6-11.2-10-26.1-24.5-40.9-42-10.8-12.8-20.9-26.6-29.6-41.1-1.2 1.6-2.3 3.3-3.5 4.9-5.7 7.8-11.5 15.2-17.3 22.2 37.7 57.5 90 96.7 90 96.7zm32 6.2l16.7 41.8-33.5 0 16.7-41.8zM144 112l16 0 0-32-16 0c-35.3 0-64 28.7-64 64l0 16 32 0 0-16c0-17.7 14.3-32 32-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;